import Prism from "prismjs";

export const getPrismLanguages = (languages: Prism.Languages): Prism.Languages =>
    Object.assign(
        languages,
        {
            'python3':              languages.python,
            'python3-ds':           languages.python,
            'cpp-no-optimization':  languages.cpp,
            '1c':                   languages.bsl
        }
    )
;
